<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action>
            <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
              <h1 class="font-weight-bold text-center w-75">COMPANY HISTORY</h1>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Has any Insurer ever cancelled, restricted or refused to renew your policy or any coverage in the past 5 years?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasAnyInsurerEverCancelled"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.hasAnyInsurerEverCancelled"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasAnyInsurerEverCancelled"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.hasAnyInsurerEverCancelled"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('hasAnyInsurerEverCancelled')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('hasAnyInsurerEverCancelled') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.hasAnyInsurerEverCancelled == true || rcApplication.hasAnyInsurerEverCancelled === 'true'">
                <label for class="orep-label">
                  If yes, please explain:
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.hasAnyInsurerEverCancelled == true || rcApplication.hasAnyInsurerEverCancelled === 'true'"
                  name="hasAnyInsurerEverCancelledDetails"
                  v-model="rcApplication.hasAnyInsurerEverCancelledDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Does applicant have any subsidiaries or related entities not listed above?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantHaveAnySubsidiaries"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.doesApplicantHaveAnySubsidiaries"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantHaveAnySubsidiaries"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.doesApplicantHaveAnySubsidiaries"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('doesApplicantHaveAnySubsidiaries')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('doesApplicantHaveAnySubsidiaries') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.doesApplicantHaveAnySubsidiaries == true || rcApplication.doesApplicantHaveAnySubsidiaries === 'true'">
                <label for class="orep-label">
                  If yes, please describe your obligations for past, present & future liabilities:
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.doesApplicantHaveAnySubsidiaries == true || rcApplication.doesApplicantHaveAnySubsidiaries === 'true'"
                  name="doesApplicantHaveAnySubsidiariesDetails"
                  v-model="rcApplication.doesApplicantHaveAnySubsidiariesDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Has applicant, or any affiliated, related or predecessor entity ever been (or is currently) the subject of bankruptcy, reorganization, solvency, dissolution, or other debtor related proceeding, or has it made an assignment for the benefit of creditors?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasApplicantEverBeenBankruptcy"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.hasApplicantEverBeenBankruptcy"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasApplicantEverBeenBankruptcy"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.hasApplicantEverBeenBankruptcy"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('hasApplicantEverBeenBankruptcy')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('hasApplicantEverBeenBankruptcy') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.hasApplicantEverBeenBankruptcy == true || rcApplication.hasApplicantEverBeenBankruptcy === 'true'">
                <label for class="orep-label">
                  If yes, please explain:
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.hasApplicantEverBeenBankruptcy == true || rcApplication.hasApplicantEverBeenBankruptcy === 'true'"
                  name="hasApplicantEverBeenBankruptcyDetails"
                  v-model="rcApplication.hasApplicantEverBeenBankruptcyDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Have there been any mergers/acquisitions, consolidations or divestitures?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="haveThereAnyMergerConsolidations"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.haveThereAnyMergerConsolidations"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="haveThereAnyMergerConsolidations"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.haveThereAnyMergerConsolidations"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('haveThereAnyMergerConsolidations')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('haveThereAnyMergerConsolidations') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.haveThereAnyMergerConsolidations == true || rcApplication.haveThereAnyMergerConsolidations === 'true'">
                <label for class="orep-label">
                  If yes, please describe your obligations for past, present & future liabilities:
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.haveThereAnyMergerConsolidations == true || rcApplication.haveThereAnyMergerConsolidations === 'true'"
                  name="haveThereAnyMergerConsolidationsDetails"
                  v-model="rcApplication.haveThereAnyMergerConsolidationsDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Has this business ever operated under a different name?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasThisBusinessEverOperatedDifferentName"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.hasThisBusinessEverOperatedDifferentName"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasThisBusinessEverOperatedDifferentName"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.hasThisBusinessEverOperatedDifferentName"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('hasThisBusinessEverOperatedDifferentName')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('hasThisBusinessEverOperatedDifferentName') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.hasThisBusinessEverOperatedDifferentName == true || rcApplication.hasThisBusinessEverOperatedDifferentName === 'true'">
                <label for class="orep-label">
                  If yes, please describe your obligations for past, present & future liabilities:
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.hasThisBusinessEverOperatedDifferentName == true || rcApplication.hasThisBusinessEverOperatedDifferentName === 'true'"
                  name="hasThisBusinessEverOperatedDifferentNameDetails"
                  v-model="rcApplication.hasThisBusinessEverOperatedDifferentNameDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                Please describe any significant changes in operations or services over the last 12 months, including any operations or services that have been discontinued, sold or abandoned, or any operations that have been acquired:
              </label>
              <input
                type="text"
                class="orep-text-input w-100"
                name="significantChangesInOperationsLast12Months"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
                v-model="rcApplication.significantChangesInOperationsLast12Months"
              >
              <span
                v-show="errors.has('significantChangesInOperationsLast12Months')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('significantChangesInOperationsLast12Months') | filterText }}</span>
            </article>

            <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
              <h2 class="font-weight-bold text-center w-75">COMPLIANCE HISTORY AND FUTURE PLANS</h2>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    During the past five (5) years, have you been cited or prosecuted for any violation of any applicable environmental law and/or federal, state or local regulation arising from the release or spill of hazardous substances, hazardous waste or any other pollutants?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="prosecutedForAnyViolationInPast5Years"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.prosecutedForAnyViolationInPast5Years"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="prosecutedForAnyViolationInPast5Years"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.prosecutedForAnyViolationInPast5Years"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('prosecutedForAnyViolationInPast5Years')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('prosecutedForAnyViolationInPast5Years') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.prosecutedForAnyViolationInPast5Years == true || rcApplication.prosecutedForAnyViolationInPast5Years === 'true'">
                <label for class="orep-label">
                  If yes, please provide details?
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.prosecutedForAnyViolationInPast5Years == true || rcApplication.prosecutedForAnyViolationInPast5Years === 'true'"
                  name="prosecutedForAnyViolationInPast5YearsDetails"
                  v-model="rcApplication.prosecutedForAnyViolationInPast5YearsDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Are there any statutes, standards, or other city, state and/or federal regulations relating to the protection of the environment with which you cannot at the present comply with?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="anyStatutesThatCannotPresentComply"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.anyStatutesThatCannotPresentComply"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="anyStatutesThatCannotPresentComply"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.anyStatutesThatCannotPresentComply"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('anyStatutesThatCannotPresentComply')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('anyStatutesThatCannotPresentComply') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.anyStatutesThatCannotPresentComply == true || rcApplication.anyStatutesThatCannotPresentComply === 'true'">
                <label for class="orep-label">
                  If yes, please provide details?
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.anyStatutesThatCannotPresentComply == true || rcApplication.anyStatutesThatCannotPresentComply === 'true'"
                  name="anyStatutesThatCannotPresentComplyDetails"
                  v-model="rcApplication.anyStatutesThatCannotPresentComplyDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Have you been subject to third party claims as a result of a pollution event from a non-owned disposal facility?                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="haveYouBeenThirdPartyClaim"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.haveYouBeenThirdPartyClaim"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="haveYouBeenThirdPartyClaim"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.haveYouBeenThirdPartyClaim"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('haveYouBeenThirdPartyClaim')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('haveYouBeenThirdPartyClaim') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.haveYouBeenThirdPartyClaim == true || rcApplication.haveYouBeenThirdPartyClaim === 'true'">
                <label for class="orep-label">
                  If yes, please provide details?
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.haveYouBeenThirdPartyClaim == true || rcApplication.haveYouBeenThirdPartyClaim === 'true'"
                  name="haveYouBeenThirdPartyClaimDetails"
                  v-model="rcApplication.haveYouBeenThirdPartyClaimDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Do you have an outside contractor, firm or one person who is responsible for environmental and/or compliance management services?                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doYouHaveOutsideContractor"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.doYouHaveOutsideContractor"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doYouHaveOutsideContractor"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.doYouHaveOutsideContractor"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('doYouHaveOutsideContractor')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('doYouHaveOutsideContractor') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.doYouHaveOutsideContractor == true || rcApplication.doYouHaveOutsideContractor === 'true'">
                <label for class="orep-label">
                  If yes, please provide details?
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.doYouHaveOutsideContractor == true || rcApplication.doYouHaveOutsideContractor === 'true'"
                  name="doYouHaveOutsideContractorDetails"
                  v-model="rcApplication.doYouHaveOutsideContractorDetails"
                >
              </div>
            </article>

            <article class="form-heading form-section review-sign"  v-if="rcApplication.doYouHaveOutsideContractor == true || rcApplication.doYouHaveOutsideContractor === 'true'">
              <div class="row">
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <label class="orep-label notice-form-date">Name of Firm:</label>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your Name of Firm"
                      name="nameOfFirm"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="rcApplication.nameOfFirm"
                    >
                    <span
                      v-show="errors.has('nameOfFirm')"
                      class="help is-danger form-errors text-danger col-md-6"
                    >{{ errors.first('nameOfFirm') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <label class="orep-label notice-form-date">Contact:</label>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Contact"
                      name="appraiserContact"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="rcApplication.appraiserContact"
                    >
                    <span
                      v-show="errors.has('appraiserContact')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('appraiserContact') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <label class="orep-label notice-form-date">Phone Number:</label>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your Phone Number"
                      name="appraiserPhoneNumber"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="rcApplication.appraiserPhoneNumber"
                    >
                    <span
                      v-show="errors.has('appraiserPhoneNumber')"
                      class="help is-danger form-errors text-danger col-md-6"
                    >{{ errors.first('appraiserPhoneNumber') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <label class="orep-label notice-form-date">E-mail:</label>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your E-mail"
                      name="appraiserEmail"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="rcApplication.appraiserEmail"
                    >
                    <span
                      v-show="errors.has('appraiserEmail')"
                      class="help is-danger form-errors text-danger col-md-6"
                    >{{ errors.first('appraiserEmail') | filterText }}</span>
                  </section>
                </div>
              </div>
            </article>


            <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
              <h1 class="font-weight-bold text-center w-75">CLAIMS</h1>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Have any claims been made within the past 5 years against the applicant or reported under any Commercial General Liability, Contractors Pollution Liability, or Professional Liability policies?                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="haveAnyClaimsEverBeenMadeAgainstApplicant"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.haveAnyClaimsEverBeenMadeAgainstApplicant"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="haveAnyClaimsEverBeenMadeAgainstApplicant"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.haveAnyClaimsEverBeenMadeAgainstApplicant"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('haveAnyClaimsEverBeenMadeAgainstApplicant')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('haveAnyClaimsEverBeenMadeAgainstApplicant') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.haveAnyClaimsEverBeenMadeAgainstApplicant == true || rcApplication.haveAnyClaimsEverBeenMadeAgainstApplicant === 'true'">
                <label for class="orep-label">
                  If yes, please provide details (use additional paper if necessary):
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.haveAnyClaimsEverBeenMadeAgainstApplicant == true || rcApplication.haveAnyClaimsEverBeenMadeAgainstApplicant === 'true'"
                  name="haveAnyClaimsEverBeenMadeAgainstApplicantDetails"
                  v-model="rcApplication.haveAnyClaimsEverBeenMadeAgainstApplicantDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Are you aware of any fact, circumstance or situation which could result in a claim being made against you or any other entity for which coverage is being requested?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="areYouAwareAnySituationClaimCoverage"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.areYouAwareAnySituationClaimCoverage"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="areYouAwareAnySituationClaimCoverage"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.areYouAwareAnySituationClaimCoverage"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('areYouAwareAnySituationClaimCoverage')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('areYouAwareAnySituationClaimCoverage') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.areYouAwareAnySituationClaimCoverage == true || rcApplication.areYouAwareAnySituationClaimCoverage === 'true'">
                <label for class="orep-label">
                  If yes, please provide details (use additional paper if necessary):
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.areYouAwareAnySituationClaimCoverage == true || rcApplication.areYouAwareAnySituationClaimCoverage === 'true'"
                  name="areYouAwareAnySituationClaimCoverageDetails"
                  v-model="rcApplication.areYouAwareAnySituationClaimCoverageDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Has any staff member or employee been the subject of disciplinary action by authorities as a result of Contracting Operations or Professional Services?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasAnyStaffDisciplinaryAction"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.hasAnyStaffDisciplinaryAction"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasAnyStaffDisciplinaryAction"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.hasAnyStaffDisciplinaryAction"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('hasAnyStaffDisciplinaryAction')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('hasAnyStaffDisciplinaryAction') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.hasAnyStaffDisciplinaryAction == true || rcApplication.hasAnyStaffDisciplinaryAction === 'true'">
                <label for class="orep-label">
                  If yes, describe (use additional paper if necessary):
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.hasAnyStaffDisciplinaryAction == true || rcApplication.hasAnyStaffDisciplinaryAction === 'true'"
                  name="hasAnyStaffDisciplinaryActionDetails"
                  v-model="rcApplication.hasAnyStaffDisciplinaryActionDetails"
                >
              </div>
            </article>


            <article class="input-section form-heading form-section review-sign">
              <div class="row">
                <p class="mt-4 mb-0 mx-5">
                  <strong>Consent to Electronic Signature: </strong>
                  I Wish to Sign Electronically. By typing my name below, I hereby sign my application and consent to the use of electronic signature for the purposes of this insurance application. (Please email <a href="mailto:info@orep.org" target="_top">info@orep.org</a> if you do not consent to Electronic Signature.)
                </p>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Please print your name:</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your Name"
                      name="appraiserEsignatureName"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="rcApplication.appraiserEsignatureName"
                    >
                    <span
                      v-show="errors.has('appraiserEsignatureName')"
                      class="help is-danger form-errors text-danger col-md-6"
                    >{{ errors.first('appraiserEsignatureName') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Title:</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Title"
                      name="appraiserEsignatureTitle"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="rcApplication.appraiserEsignatureTitle"
                    >
                    <span
                      v-show="errors.has('appraiserEsignatureTitle')"
                      class="help is-danger form-errors text-danger col-md-6"
                    >{{ errors.first('appraiserEsignatureTitle') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Signature:</p>
                    <input
                      type="text"
                      class="orep-text-input notice-input"
                      placeholder="Type Your Name to Sign"
                      name="appraiserEsignature"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="rcApplication.appraiserEsignature"
                    >
                    <span
                      v-show="errors.has('appraiserEsignature')"
                      class="help is-danger form-errors text-danger col-md-6"
                    >{{ errors.first('appraiserEsignature') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Date:</p>
                    <input
                      type="date"
                      class="orep-text-input notice-input text-center"
                      :value="formattedCurrentDate()"
                      disabled
                    >
                  </section>
                </div>
              </div>
            </article>
            <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
              <h2 class="font-weight-bold text-center w-75">FRAUD WARNING</h2>
            </article>
            <section class="state-law" style="margin-top: 50px">
              <p >
                <strong><u>NOTICE TO ALABAMA APPLICANTS:</u> Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or who knowingly presents false information in an application for insurance is guilty of a crime and may be subject to restitution fines or confinement in prison, or any combination thereof.
                </strong>
              </p>
              <p>
                <strong><u>NNOTICE TO ARKANSAS APPLICANTS:</u>Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.
                </strong>

              </p>
              <p>
                <strong><u>NOTICE TO CALIFORNIA APPLICANTS:</u>
                  For your protection California law requires the following to appear on this form: Any person who knowingly presents a false or fraudulent claim for the payment of a loss is guilty of a crime and may be subject to fines and confinement in state prison.
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO COLORADO APPLICANTS:</u>
                  It is unlawful to knowingly provide false, incomplete or misleading facts or information to an insurance company for the purpose of defrauding or attempting to defraud the company. Penalties may include imprisonment, fines, denial of insurance and civil damages. Any insurance company or agent of an insurance company who knowingly provides false, incomplete or misleading facts or information to a policy holder or claimant for the purpose of defrauding or attempting to defraud the policyholder or claiming with regard to a settlement or award payable for insurance proceeds shall be reported to the Colorado Division of Insurance within the Department of regulatory agencies.
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO DISTRICT OF COLUMBIA APPLICANTS:</u>
                  WARNING: It is a crime to provide false or misleading information to an insurer for the purpose of defrauding the insurer or any other person. Penalties include imprisonment and/or fines. In addition, an insurer may deny insurance benefits if false information materially related to a claim was provided by the applicant.
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO FLORIDA APPLICANTS:</u>
                  Any person who knowingly and with intent to injure, defraud or deceive any insurance company files a statement of claim or an application containing any false, incomplete or misleading information is guilty of a felony of the third degree.
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO KENTUCKY APPLICANTS:</u>
                  Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance containing any materially false information or conceals, for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime.
                </strong>
              </p>
              <p >
                <strong><u>NOTICE TO LOUISIANA APPLICANTS:</u>
                  Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO MAINE APPLICANTS:</u>
                  It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties may include imprisonment, fines or a denial of insurance benefits.
                </strong>

              </p>
              <p>
                <strong><u>NOTICE TO MARYLAND APPLICANTS:</u>
                  Any person who knowingly or willfully presents a false or fraudulent claim for payment of a loss or benefit or who knowingly or willfully presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO NEW JERSEY APPLICANTS:</u>
                  Any person who includes any false or misleading information on a application for an insurance policy is subject to criminal and civil penalties.
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO NEW MEXICO APPLICANTS:</u>
                  Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to civil fines and criminal penalties.
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO NEW YORK APPLICANTS:</u>
                  Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information, or conceals for the purpose of misleading, information concerning any fact material thereto, commits a fraudulent insurance act, which is a crime, and shall also be subject to a civil penalty not to exceed five thousand dollars and the stated value of the claim for each such violation.
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO OHIO APPLICANTS:</u>
                  Any person who, with intent to defraud or knowing that he is facilitating a fraud against an insurer, submits an application or files a claim containing a false or deceptive statement is guilty of insurance fraud.
                </strong>
              </p>
              <p >
                <strong><u>NOTICE TO OKLAHOMA APPLICANTS:</u>
                  WARNING: Any person who knowingly, and with intent to injure, defraud or deceive any insurer, makes any claim for the proceeds of an insurance policy containing any false, incomplete or misleading information is guilty of a felony.
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO PENNSYLVANIA APPLICANTS:</u>
                  Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.
                </strong>

              </p>
              <p>
                <strong><u>NOTICE TO RHODE ISLAND:</u>
                  Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO TENNESSEE APPLICANTS:</u>
                  It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties include imprisonment, fines and denial of insurance benefits.
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO VIRGINIA APPLICANTS:</u>
                  It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties include imprisonment, fines and denial of insurance benefits.
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO WASHINGTON APPLICANTS:</u>
                  It is a crime to knowingly provide false, incomplete, or misleading information to an insurance company for the purposes of defrauding the company. Penalties include imprisonment, fines, and denial of insurance benefits
                </strong>
              </p>
              <p>
                <strong><u>NOTICE TO ALL OTHER STATE APPLICANTS:</u>
                  Any person who knowingly, and with intent to defraud any insurance company or other person, files an application for insurance or statement of claim containing any materially false information, or, for the purpose of misleading, conceals information concerning any fact material thereto, may commit a fraudulent insurance act which is a crime in many states.
                </strong>
              </p>
            </section>

          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'rc-application-4'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('rc-application-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('rc-application-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('rc-application-3')"></button>
              <button
                class="pagination-dots"
                @click="navigateToPrev('rc-application-4')">
              </button>
              <span class="pagination-dots pagination-current"></span>
              <button
                class="pagination-dots"
                @click="navigateToNext('rc-application-6')"
                :disabled="!state.pageFiveIsValid">
              </button>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              :disabled="!state.pageFiveIsValid"
              :class="{submitDisabled: !state.pageFiveIsValid}"
              @click="navigateToNext('rc-application-6')"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Submitting the application...</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import {APP_STATUS} from "@/utils/constants";
import Datepicker from "vuejs-datepicker";

export default {
  name: "rc-application-5",
  data() {
    return {
      loading: false
    };
  },
  computedDates() {
    return moment(this.value).format('YYYY-MM-D')
  },
  computed: {
    rcApplication() {
      return this.$store.state.rcApplication.rcApplication;
    },
    state() {
      return this.$store.state.rcApplication;
    },
    errorMsg() {
      return this.$store.state.rcApplication.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    navigateToPrev(route) {
      this.$router.push({
        name: route
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageFiveIsValid = true;
          return;
        }
        this.state.pageFiveIsValid = false;
      });
    },

    formattedCurrentDate() {
      return moment(this.rcApplication.appraiserEsignatureDatetime).format('YYYY-MM-DD');
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    formSubmit() {
      this.loading = true;
      this.state.rcApplication.customer.appStatus = APP_STATUS.Completed;
      this.$store.dispatch('rcApplication/createRcApplication');
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  components: {}
};
</script>

<style scoped>
table td, table th {
  border: 1px solid black;
}
table th {
  height: 35px;
}
table td, table th {
  text-align: center;
  max-width: 140px;
}
table input {
  width: 100%;
  text-align: center;
}
</style>


